"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

require("core-js/modules/es6.number.constructor");

var _multiUserSelect = _interopRequireDefault(require("@/views/cms/common/multiUserSelect"));

var _cust = _interopRequireDefault(require("@/api/cust"));

var _storeInto = require("@/api/storeInto");

var _cmsWorkOrder = require("@/api/cmsWorkOrder");

var _custWorkOrder = require("@/api/custWorkOrder");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default2 = {
  name: 'StoreInto',
  components: {
    UserSelect: _multiUserSelect.default
  },
  props: {
    custId: {
      type: [String, Number],
      required: true
    },
    storeInto: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      form: {},
      storeSeller: [],
      storeManager: [],
      storeName: [],
      storeDepts: [],
      storeSellerNickName: [],
      storeManagerNickName: [],
      planMeasureTime: '',
      isMeasureSure: '',
      designerList: [],
      dispatchDesignerList: [],
      showUserSelect: false,
      currentSelectType: ''
    };
  },
  mounted: function mounted() {
    this.init();
    this.fetchDesignerInfo();
  },
  watch: {
    custId: {
      handler: function handler(newVal) {
        if (newVal) {
          this.init();
          this.fetchDesignerInfo();
        }
      }
    },
    storeInto: {
      handler: function handler(newVal) {
        if (newVal) {
          this.init();
        }
      }
    }
  },
  methods: {
    init: function init() {
      // 初始化数据
      this.storeSeller = [];
      this.storeName = [];
      this.storeManager = [];
      this.storeSellerNickName = [];
      this.storeManagerNickName = [];
      this.storeDepts = []; // 新增清空计划测量时间

      this.planMeasureTime = '';
      this.isMeasureSure = ''; // 从storeInto数据中加载门店信息

      if (this.storeInto) {
        // 解析门店名称
        if (this.storeInto.storeName) {
          this.storeName = [this.storeInto.storeName];
        } // 新增：赋值计划测量时间，后端字段可能在 storeInto.planMeasureTime 或 storeInto.measureInto.planMeasureTime


        try {
          if (this.storeInto.planMeasureTime) {
            this.planMeasureTime = this.storeInto.planMeasureTime;
          } else if (this.storeInto.measureInto) {
            var mi = typeof this.storeInto.measureInto === 'string' ? JSON.parse(this.storeInto.measureInto) : this.storeInto.measureInto;
            this.planMeasureTime = mi && mi.planMeasureTime ? mi.planMeasureTime : '';
          } else {
            this.planMeasureTime = '';
          }
        } catch (e) {
          console.error('解析 planMeasureTime 失败:', e);
          this.planMeasureTime = '';
        } // 初始化是否测未定


        this.isMeasureSure = this.storeInto.isMeasureSure || ''; // 解析门店导购信息

        if (this.storeInto.storeSeller) {
          try {
            this.storeSeller = JSON.parse(this.storeInto.storeSeller);
          } catch (e) {
            console.error('解析storeSeller失败:', e);
            this.storeSeller = [];
          }
        } // 解析门店导购昵称


        if (this.storeInto.storeSellerNick) {
          try {
            this.storeSellerNickName = JSON.parse(this.storeInto.storeSellerNick);
          } catch (e) {
            console.error('解析storeSellerNick失败:', e);
            this.storeSellerNickName = [];
          }
        } // 解析门店店长信息


        if (this.storeInto.storeManager) {
          try {
            this.storeManager = JSON.parse(this.storeInto.storeManager);
          } catch (e) {
            console.error('解析storeManager失败:', e);
            this.storeManager = [];
          }
        } // 解析门店店长昵称


        if (this.storeInto.storeManagerNick) {
          try {
            this.storeManagerNickName = JSON.parse(this.storeInto.storeManagerNick);
          } catch (e) {
            console.error('解析storeManagerNick失败:', e);
            this.storeManagerNickName = [];
          }
        }
      }
    },
    // 从custWorkOrder接口获取设计师和设计中心派单员信息
    fetchDesignerInfo: function fetchDesignerInfo() {
      var _this = this;

      if (!this.custId) return;
      (0, _custWorkOrder.getByCustId)(this.custId).then(function (res) {
        // 兼容两种返回格式：res.content 或 res.data.content
        var list = res && res.content ? res.content : res && res.data && res.data.content ? res.data.content : null;

        if (list) {
          _this.designerList = list.filter(function (item) {
            return item.type === '设计师' && item.status === '待跟进';
          });
          _this.dispatchDesignerList = list.filter(function (item) {
            return item.type === '设计中心派单员' && item.status === '待跟进';
          });
          console.log('设计师信息:', _this.designerList, '设计中心派单员:', _this.dispatchDesignerList);
        }
      }).catch(function (err) {
        console.error('获取工单人员信息失败:', err);
      });
    },
    // 打开用户选择
    onUserSelect: function onUserSelect(type) {
      this.currentSelectType = type;
      this.showUserSelect = true;
      this.$refs.userSelect.selectType = type; // 根据选择类型设置不同的已选用户

      var selectedUsers = [];
      var selectedUserNames = [];

      if (type === '门店店长') {
        selectedUsers = Array.isArray(this.storeManagerNickName) ? this.storeManagerNickName : this.storeManagerNickName ? [this.storeManagerNickName] : [];
        selectedUserNames = Array.isArray(this.storeManager) ? this.storeManager : this.storeManager ? [this.storeManager] : [];
      } else if (type === '门店导购') {
        selectedUsers = Array.isArray(this.storeSellerNickName) ? this.storeSellerNickName : this.storeSellerNickName ? [this.storeSellerNickName] : [];
        selectedUserNames = Array.isArray(this.storeSeller) ? this.storeSeller : this.storeSeller ? [this.storeSeller] : [];
      } else if (type === '设计师') {
        selectedUsers = (this.storeInto.storeDesignerNick || this.storeInto.storeDesignerNickName || []).map(function (v) {
          return typeof v === 'string' ? v : '';
        }).filter(Boolean);
        selectedUserNames = (this.storeInto.storeDesigner || this.storeInto.storeDesignerName || []).map(function (v) {
          return typeof v === 'string' ? v : '';
        }).filter(Boolean); // 如果 storeInto 中没有设计师数据，则从 designerList 取

        if (selectedUsers.length === 0) {
          selectedUsers = this.designerList.map(function (item) {
            return item.user ? item.user.nickName : '';
          }).filter(Boolean);
          selectedUserNames = this.designerList.map(function (item) {
            return item.userName;
          }).filter(Boolean);
        }
      } else if (type === '设计中心派单员') {
        selectedUsers = this.dispatchDesignerList.map(function (item) {
          return item.user ? item.user.nickName : '';
        }).filter(Boolean);
        selectedUserNames = this.dispatchDesignerList.map(function (item) {
          return item.userName;
        }).filter(Boolean);
      }

      this.$refs.userSelect.nickNames = selectedUsers;
      this.$refs.userSelect.userNames = selectedUserNames;
      this.$refs.userSelect.isFirst = true;
      this.$refs.userSelect.getDeptDatas(type);
    },
    // 关闭用户选择
    onUserSelectClose: function onUserSelectClose() {
      this.showUserSelect = false;
      this.currentSelectType = '';
    },
    // 选择用户回调
    selectUserCallBack: function selectUserCallBack(user) {
      var _this2 = this;

      console.log(user); // 验证custId是否存在

      if (!this.custId) {
        this.$notify({
          title: '分配失败',
          type: 'error',
          duration: 1500,
          message: '客户ID不存在，无法分配'
        });
        this.showUserSelect = false;
        return;
      }

      var changeInfo = {
        type: user.selectType,
        custId: this.custId,
        userNames: user.userNames,
        nickNames: user.nickNames
      };

      _cust.default.allotSelectUsers(changeInfo).then(function (res) {
        // 检查API响应状态码
        if (res && res.code === 200) {
          // 类型为设计师或设计中心派单员时立即更新本地列表回显
          if (changeInfo.type === '设计师' || changeInfo.type === '设计中心派单员') {
            var nickNames = Array.isArray(user.nickNames) ? user.nickNames : user.nickNames ? [user.nickNames] : [];
            var userNames = Array.isArray(user.userNames) ? user.userNames : user.userNames ? [user.userNames] : [];
            var list = nickNames.map(function (nick, i) {
              return {
                userName: userNames[i] || '',
                user: {
                  nickName: nick
                }
              };
            });

            if (changeInfo.type === '设计师') {
              _this2.designerList = list;
            } else {
              _this2.dispatchDesignerList = list;
            }
          }

          _this2.$notify({
            title: '分配成功',
            type: 'success',
            duration: 1500
          });

          _this2.showUserSelect = false; // 重新查询客户接口以获取最新数据

          if (_this2.custId) {
            (0, _cmsWorkOrder.getCustInfo)(_this2.custId).then(function (response) {
              console.log(response);

              if (response && response.data) {
                var latestCustomer = response.data; // 触发事件通知父组件更新数据

                _this2.$emit('refresh-store-data', latestCustomer);
              }
            }).catch(function (error) {
              console.error('重新获取客户数据失败:', error);
            });
          }
        } else {
          _this2.showUserSelect = false;

          _this2.$notify({
            title: '分配失败',
            type: 'error',
            duration: 1500,
            message: res.msg || '分配失败，请重试'
          });
        }
      }).catch(function (err) {
        _this2.showUserSelect = false;
        console.log(err.response.data.message);

        _this2.$notify({
          title: '分配失败',
          type: 'error',
          duration: 1500,
          message: err.response.data.message || '分配失败，请重试'
        });
      });
    },
    onPlanMeasureTimeChange: function onPlanMeasureTimeChange(value) {
      var _this3 = this;

      // 直接写入顶级字段 storeInto.planMeasureTime，项目里该字段存在于顶级
      var updated = _objectSpread(_objectSpread({}, this.storeInto || {}), {}, {
        planMeasureTime: value
      }); // 仅同步给父组件，父组件负责统一保存流程


      this.$emit('update:storeInto', updated); // 立即提交到后端保存

      (0, _storeInto.editStoreInto)(updated).then(function () {
        _this3.$notify({
          title: '保存成功',
          type: 'success',
          duration: 1500
        });

        if (_this3.custId) {
          (0, _cmsWorkOrder.getCustInfo)(_this3.custId).then(function (response) {
            if (response && response.data) {
              _this3.$emit('refresh-store-data', response.data);
            } else if (response) {
              _this3.$emit('refresh-store-data', response);
            }
          }).catch(function (error) {
            console.error('重新获取客户数据失败:', error);
          });
        }
      }).catch(function (error) {
        console.error('保存计划测量时间失败:', error);

        _this3.$notify({
          title: '保存失败',
          type: 'error',
          duration: 1500,
          message: error && error.response && error.response.data && error.response.data.message ? error.response.data.message : '保存计划测量时间失败'
        });
      });
    },
    onIsMeasureSureChange: function onIsMeasureSureChange(value) {
      var _this4 = this;

      var updated = _objectSpread(_objectSpread({}, this.storeInto || {}), {}, {
        isMeasureSure: value
      });

      this.$emit('update:storeInto', updated);
      (0, _storeInto.editStoreInto)(updated).then(function () {
        _this4.$notify({
          title: '保存成功',
          type: 'success',
          duration: 1500
        });

        if (_this4.custId) {
          (0, _cmsWorkOrder.getCustInfo)(_this4.custId).then(function (response) {
            if (response && response.data) {
              _this4.$emit('refresh-store-data', response.data);
            } else if (response) {
              _this4.$emit('refresh-store-data', response);
            }
          }).catch(function (error) {
            console.error('重新获取客户数据失败:', error);
          });
        }
      }).catch(function (error) {
        console.error('保存是否测未定失败:', error);

        _this4.$notify({
          title: '保存失败',
          type: 'error',
          duration: 1500,
          message: error && error.response && error.response.data && error.response.data.message ? error.response.data.message : '保存是否测未定失败'
        });
      });
    },
    validate: function validate() {
      return new Promise(function (resolve) {
        // 门店信息表单验证逻辑
        resolve(true);
      });
    }
  }
};
exports.default = _default2;